import {
  inline_alert_styles_default
} from "./chunk.25ODJMVS.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/inline-alert/inline-alert.ts
var FadvInlineAlert = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "prefix", "suffix");
    this.variant = "success";
    this.rounded = false;
    this.outline = false;
    this.bordered = false;
  }
  render() {
    return $`<div part="base" class=${o({
      "inline-alert": true,
      "inline-alert--primary": this.variant === "primary",
      "inline-alert--secondary": this.variant === "secondary",
      "inline-alert--tertiary": this.variant === "tertiary",
      "inline-alert--neutral": this.variant === "neutral",
      "inline-alert--success": this.variant === "success",
      "inline-alert--warning": this.variant === "warning",
      "inline-alert--danger": this.variant === "danger",
      "inline-alert--has-prefix": this.hasSlot.test("prefix"),
      "inline-alert--has-suffix": this.hasSlot.test("suffix"),
      "inline-alert--rounded": this.rounded,
      "inline-alert--outline": this.outline,
      "inline-alert--bordered": this.bordered
    })} ><span part="prefix" class=${o({
      "inline-alert__icon": true,
      "inline-alert__prefix": true
    })} ><slot name="prefix"></slot></span><fadv-typography type="paragraph-medium"><slot></slot></fadv-typography><span part="suffix" class=${o({
      "inline-alert__icon": true,
      "inline-alert__suffix": true
    })} ><slot name="suffix"></slot></span></div>`;
  }
};
FadvInlineAlert.styles = inline_alert_styles_default;
__decorateClass([
  e()
], FadvInlineAlert.prototype, "variant", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInlineAlert.prototype, "rounded", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInlineAlert.prototype, "outline", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInlineAlert.prototype, "bordered", 2);
FadvInlineAlert = __decorateClass([
  n("fadv-inline-alert")
], FadvInlineAlert);

export {
  FadvInlineAlert
};
